import React, { useState, useCallback, useEffect, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Toolbar, Box, IconButton, Badge, AppBar, ListSubheader, TextField } from '@mui/material';
import Popover from '@mui/material/Popover';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import MenuItem from '@mui/material/MenuItem'
import Tooltip from "@mui/material/Tooltip";
import CircleNotificationsOutlinedIcon from '@mui/icons-material/CircleNotificationsOutlined';
import logo from '../assetts/images/sum-theory-logo.png';
import timezone from '../assetts/images/timeZone.svg'
import NotificationsDropdown from './notifications/NotificationsDropdown';
import { useNotifications } from '../hooks/useNotifications';
import { useNotificationSSE } from '../hooks/useNotificationSSE';
import { useNavigate } from 'react-router-dom';
import { timeZoneListfetch } from '../api/commonApis';
import PartnerCustomerDropdown from '../pages/PartnerDashboard/components/PartnerCustomerDropdown';
import { updateUnreadeNotifications } from '../redux/actions/actions';
import { useSound } from '../contexts/SoundContext';

const Navbar = () => {
  const dispatch = useDispatch();
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const accessToken = localStorage.getItem('accessToken');
  const unreadnotifications = useSelector(state => state?.notifications?.unread_notifications ?? []);
  const unreadnotificationsCount = useSelector(state => state?.notifications?.unread_count ?? 0);
  const partnerCustomer = useSelector((state) => state.partner.partnerCustomer);
  const userType = useSelector((state) => state.auth.userDetails?.user_type);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const {
    loading,
    markAsRead,
    markAsUnread,
    refreshUnreadNotifications
  } = useNotifications(accessToken);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [timeZone, setTimezone] = useState([])
  const [selectedTimeZone, setSelectedTimeZone] = useState(localStorage.getItem('timeZone'));
  const [searchTerm, setSearchTerm] = useState('');
  const selectedRef = useRef(null)
  const scrollContainerRef = useRef(null);
  const toggleButtonRef = useRef(null);

  const { playSound } = useSound();

  const filteredTimeZones = useMemo(() => {
    if (!timeZone?.length) return [];

    return timeZone.filter(tz =>
      tz.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [timeZone, searchTerm]);

  useEffect(() => {
    refreshUnreadNotifications(1);
  }, []);
  // Handle SSE notification events
  const handleNotificationEvent = useCallback((data) => {
    console.log('[SSE] event received ✅', data); // ← is this printing when notification comes?
    console.log('[playSound] about to call playSound');
    playSound()
    playSound();
    if (dropdownVisible) {
      refreshUnreadNotifications();
    }
    refreshUnreadNotifications();
  }, [dropdownVisible, refreshUnreadNotifications, playSound]);

  // Setup SSE connection
  useNotificationSSE(accessToken, handleNotificationEvent);

  const localNotifications = useMemo(() => {
    return unreadnotifications.filter(n => !n.isRead);
  }, [unreadnotifications]);

  useEffect(() => {
    if (open && selectedRef.current) {
      setTimeout(() => {
        selectedRef.current?.scrollIntoView({ block: 'center' });
      }, 100); // short delay ensures popover is rendered
    }
  }, [open, filteredTimeZones]);

  useEffect(() => {
    if (!open) return;

    const timer = setTimeout(() => {
      const container = scrollContainerRef.current;
      const item = selectedRef.current;
      if (container && item) {
        item.scrollIntoView({ block: 'start' });
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [open, searchTerm, filteredTimeZones.length]);

  useEffect(() => {
    const getTimeZone = async (accessToken) => {

      try {
        const data = await timeZoneListfetch(accessToken)
        setTimezone(data)
      } catch (error) {

        setTimezone([])
      }
    };

    getTimeZone(accessToken)

  }, [accessToken])

  const toggleDropdown = useCallback(() => {
    if (!dropdownVisible) {
      refreshUnreadNotifications();
    }
    setDropdownVisible(!dropdownVisible);
  }, [dropdownVisible, refreshUnreadNotifications]);
  const goHome = (() => {
    if (userType === 2 || userType === 3) {
      navigate('/partner-dashboard')
    } else {
      navigate('/choicescreen', { state: { view: 'Activities' } });
    }
  })

  // Detect clicks outside the dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedOutsideDropdown = dropdownRef.current && !dropdownRef.current.contains(event.target);
      const clickedOutsideButton = toggleButtonRef.current && !toggleButtonRef.current.contains(event.target);

      if (clickedOutsideDropdown && clickedOutsideButton) {
        setDropdownVisible(false);
      }
    };

    if (dropdownVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownVisible]);

  const toggleTimeZone = (event) => {
    setAnchorEl(event.currentTarget);
    setDropdownVisible(false)
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSearchTerm('')
  };

  const handleSelectTimeZone = (zone) => {
    localStorage.setItem('timeZone', zone)
    setSelectedTimeZone(zone);
    setAnchorEl(null);
    window.location.reload();
  };
  const handleLocalDelete = useCallback((notificationIds) => {
    dispatch(updateUnreadeNotifications({
      notifications: unreadnotifications.filter(
        n => !notificationIds.includes(n.id)
      )
    }));
  }, [dispatch, unreadnotifications]);
  return (
    <AppBar position="fixed" style={styles.topbar}>
      <Toolbar sx={{ marginTop: '5px' }}>
        {/* <img src={logo} alt="Logo" style={{ height: '60%', marginRight: 16 }} /> */}
        <div onClick={() => goHome()} style={{ cursor: 'pointer', display: 'inline-block' }}>
          <img src={logo} alt="Logo" style={{ height: '60%', marginRight: 16,width:"190px" }} />
        </div>
        <Box sx={{ display: 'flex', alignItems: 'center', position: "absolute", right: partnerCustomer?.name ? '165px' : '1rem', }}>
          <Tooltip title="Timezone" arrow>
            <IconButton sx={{ color: '#B3B3B3' }} onClick={toggleTimeZone}>
              <Badge
                color="primary"
              >
                <img
                  src={timezone}
                  alt="Time Zone"
                  style={{ width: 30, height: 30, objectFit: 'contain' }}
                />
              </Badge>
            </IconButton>
          </Tooltip>
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            slotProps={{
              paper: {
                sx: {
                  width: 300,
                  height: 350,
                  overflow: 'hidden', // Don't scroll the paper itself
                },
              },
            }}
          >
            <ListSubheader disableSticky sx={{ pl: 0 }}>
              <TextField
                size="small"
                autoFocus
                placeholder="Search"
                fullWidth
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                sx={{
                  px: 1, mt: 1, '& .MuiOutlinedInput-root': {
                    borderRadius: '16px', // change to your desired radius
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}

              />
            </ListSubheader>
            <Box
              ref={scrollContainerRef}
              sx={{
                maxHeight: 290,
                overflowY: 'auto',
              }}
            >
              {Array.isArray(filteredTimeZones) && filteredTimeZones?.length > 0 ? (
                filteredTimeZones.map((type) => (
                  <MenuItem
                    key={type.id}
                    value={type.name}
                    selected={selectedTimeZone === type.name}
                    onClick={() => handleSelectTimeZone(type.name)}
                    ref={type.name === selectedTimeZone ? selectedRef : null}
                  >
                    {type.name}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No data available</MenuItem>
              )}
            </Box>
          </Popover>
          <Tooltip title="Notification" arrow>
            <IconButton ref={toggleButtonRef} sx={{ color: '#B3B3B3' }} onClick={toggleDropdown}>
              <Badge
                badgeContent={loading ? 0 : unreadnotificationsCount}
                color="primary"
              >
                <CircleNotificationsOutlinedIcon sx={{ fill: unreadnotificationsCount > 0 ? "#B3B3B3" : "#B3B3B3", stroke: "#fff", strokeWidth: 1, fontSize: 30, width: 35, height: 35 }} />
              </Badge>
            </IconButton>
          </Tooltip>
        </Box>
      </Toolbar>
      {dropdownVisible && (
        <NotificationsDropdown
          ref={dropdownRef}
          notifications={localNotifications}
          loading={loading}
          markAsRead={markAsRead}
          markAsUnread={markAsUnread}
          deleteNotifications={handleLocalDelete}
          refreshUnreadNotifications={refreshUnreadNotifications}
          type="navbar"
        />
      )}
      {partnerCustomer.name && (
        <PartnerCustomerDropdown />
      )}
    </AppBar>
  );
};

const styles = {
  topbar: {
    height: '72px',
    backgroundColor: '#F5F9FF',
    zIndex: 1000,
    borderBottom: '1px solid #D0D0D0',
    boxShadow: '0px 0px 0px 0px #00000014',
  },
};

export default Navbar;